// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'styled-components';
import { useIconSize } from '../useIconSize';
import { jsx as _jsx } from "react/jsx-runtime";
export const PowerPointFileIcon = ({
  size = 'inherit',
  color = 'inherit',
  'aria-label': ariaLabel,
  id
}) => {
  const theme = useTheme();
  const sizeValue = useIconSize(size);
  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // currentColor = color of the parent element

  return /*#__PURE__*/_jsx("svg", {
    width: sizeValue,
    height: sizeValue,
    fill: colorValue,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "PowerPointFile",
    children: /*#__PURE__*/_jsx("path", {
      d: "M27.22 10.56h-.03a2 2 0 0 0-.12-.35v-.07a1.8 1.8 0 0 0-.22-.3l-7.53-7.5c-.09-.09-.18-.16-.28-.22h-.08q-.15-.075-.33-.12H9.01c-2.32 0-4.2 1.87-4.23 4.17v20.09c0 2.2 1.73 3.74 4.21 3.74h14.02c2.47 0 4.21-1.54 4.21-3.74zm-2.84 15.7c0 .77-.76.97-1.4.97H9c-.64 0-1.4-.17-1.4-.97V6.17c0-.78.63-1.4 1.4-1.4h7.94v5.14c0 1.29 1.04 2.34 2.34 2.34h5.1v14.02Zm-8.05-11.83c1.01-.07 2.01.22 2.82.83.68.6 1.04 1.49.98 2.39 0 .63-.16 1.26-.49 1.79s-.81.95-1.37 1.22c-.65.3-1.35.45-2.07.44h-1.96v3.64h-2.01V14.43zm-2.08 5.09h1.73c.55.04 1.09-.13 1.53-.46.36-.35.55-.84.52-1.33 0-1.14-.66-1.7-1.98-1.7h-1.79v3.5Z"
    })
  });
};